import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import AuthMiddleware from "./middleware/AuthMiddleware";
import { session } from "../helpers/session_helper";

const AppRoute = ({ children }) => {
  useEffect(() => {
    // Check and refresh session on route change
    session.refreshIfNeeded();
  }, []);

  return <AuthMiddleware>{children}</AuthMiddleware>;
};

export default AppRoute;
